export const metatagizestawienia = {
  Page: {
    "meta-tagi": {
      Title:
        "TravelOne.pl ••• zestawienie ofert wczasów",
      Description:
        "TravelOne.pl ••• znajdź najlepsze oferty wczasów, last minute, tanie wakacje , zestawienie wycieczek, rezerwuj hotele, apartamenty, wczasy w Chorwacji, wakacje w Bułgarii, Turcji, Grecji, last minute w Egipcie, Tunezji",
      Keywords: []
    }
  }
};
